import {
  useMarkets77,
  useTradeCapitalMarkets,
  useTradeEs,
  useTradeItaly,
  useTradeTrdfx,
} from './appsLogic';

type TCaseOne = 'first_case'; // isRegistrationCompleted = false
type TCaseTwo = 'second_case'; // isRegistrationCompleted = true but scoreLevel = LOW;
type TCaseThree = 'third_case'; // isTradingAllowed = false;
type TCaseFour = 'fourth_case'; // isDepositAllowed = false;

export type TConditionType = TCaseOne | TCaseTwo | TCaseThree | TCaseFour;

export type TApplyCondition = () => {
  status: 'passed' | 'failed';
  action?: () => void;
};

type TUseBusinessLogic = (conditionType: TConditionType) => {
  applyCondition: TApplyCondition;
  isFirstCaseCondition: boolean;
  isSecondCaseCondition: boolean;
  isThirdCaseCondition: boolean;
};

export const useBusinessLogic: TUseBusinessLogic = conditionType => {
  const markets77 = useMarkets77(conditionType);
  const tradeCapitalMarkets = useTradeCapitalMarkets(conditionType);
  const tradeEs = useTradeEs(conditionType);
  const tradeItaly = useTradeItaly(conditionType);
  const tradeTrdfx = useTradeTrdfx(conditionType);

  const rules = {
    Markets77: markets77,
    FrontBroker: tradeCapitalMarkets,
    TradeGlobal: tradeEs,
    TradeItaly: tradeItaly,
    TrdFx: tradeTrdfx,
    PipsTrades: tradeCapitalMarkets,
    ChallengesTrades: tradeCapitalMarkets,
    Finexo: tradeCapitalMarkets,
  };

  return {
    applyCondition: () => rules[import.meta.env.VITE_BRAND](),
    isFirstCaseCondition:
      rules[import.meta.env.VITE_BRAND]().isFirstCaseCondition,
    isSecondCaseCondition:
      rules[import.meta.env.VITE_BRAND]().isSecondCaseCondition,
    isThirdCaseCondition:
      rules[import.meta.env.VITE_BRAND]().isThirdCaseCondition,
  };
};
